import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import DiscussionForm from '../Form';
import {
	fetchDiscussion,
	updateDiscussion,
} from '@resources/Discussion/actions';
import { useIntl } from 'react-intl';
import isEmpty from 'lodash.isempty';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';

const Update = (props) => {
	const {
		module,
		fetchDiscussion,
		discussion,
		updateDiscussion,
		visible,
		onCancel,
	} = props;
	const intl = useIntl();

	useEffect(() => {
		const fetchData = async () => {
			await fetchDiscussion(visible);
		};
		visible && fetchData();
	}, [fetchDiscussion, visible]);

	const handleSubmit = useCallback(
		(data) => {
			return updateDiscussion(discussion._id, data)
				.then((response) => {
					popIn(
						'success',
						intl.formatMessage({
							id: 'message.success.discussion.update',
							defaultMessage:
								'An existing Discussion entry has been successfully updated',
						})
					);

					onCancel && onCancel();
				})
				.catch((err) => Promise.reject(err));
		},
		[discussion]
	);

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.update.discussion',
					defaultMessage: 'Update Discussion',
				})}
			</Title>
			{!isEmpty(discussion) && (
				<DiscussionForm
					data={discussion}
					onSubmit={handleSubmit}
					{...props}
					module={module}
				/>
			)}
		</Modal>
	);
};

const mapStateToProps = ({
	discussion,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
}) => {
	return {
		discussion,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
	};
};

export default connect(mapStateToProps, {
	fetchDiscussion,
	updateDiscussion,
	fetchModulesBySubmoduleCode,
})(Update);
